import React, {Component} from 'react';

export default class TestSAML extends Component {
  handleClick(){
    const returnUrl = encodeURIComponent(window.location.href),
      ssoUrl = "https://wfcapi.azurewebsites.net/api/v1/sp/sso",
      token = "e0e946cc-f01a-4843-94f3-ca771879c7bc";

    fetch(`${ssoUrl}?Authorization=${token}&returnUrl=${returnUrl}`)
    .then((res) => res.json())
    .then((res) => {
      if(res.SSOUrl){
        window.location = decodeURI(res.SSOUrl)
      } else {
        console.log('GOT SAML RES',res);
      }
    })
    .catch((err) => console.log('GOT SAML ERR',err));

  }

  render(){
    return (
      <div>
        <br />
        <br />
        <h1>LOG IN WITH SAML</h1>
        <br />
        <button onClick={() => this.handleClick()}>
          Click to log in
          </button>
        <br />
        <br />
        <br />
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/pages/TestSAML/index.js